module.exports = __webpack_public_path__ + "img/new_57.50c6cc4d.jpg";